import React, { useEffect, useState } from "react";
import "../../_css/OurPlans.css";
import Card from "./Card";
import ContactUs from "./ContactUs";
import { createCheckout } from "../../requests";
import { useDispatch } from "react-redux";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { notifyError, notifySuccess } from "../../utils/helper";
import { getAllPlans } from "../../requests";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Index = () => {
  const {plan} = useLocation().state || {};
  const navigate = useNavigate();
 
  // You can set the current plan here - for now, setting it to "Premium" as an example
  const [currentPlan, setCurrentPlan] = useState("Trial");
  const [loading, setLoading] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentReady, setPaymentReady] = useState(false);
  const [plans, setPlans] = useState([]);
  const [allModules, setAllModules] = useState([]);
  const [showContactModal, setShowContactModal] = useState(false);

  const dispatch = useDispatch();

  const getAllMyPlans = async () => {
    try {
      const response = await getAllPlans();
      if (response.status == 200) {
        setPlans(response.data.plans || []);
        setAllModules(response.data.modules || []);
        setCurrentPlan(response.data.currentPlan.name || null);

        if (plan) {

          if(plan.toLowerCase() == "free") {
            return;
          }
          if(plan.toLowerCase() == "custom") {
            handleContact();
            return;
          }
          //find plan in plans array
          const planData = response.data.plans.find((p) => p.name.toLowerCase() === plan.toLowerCase());
          handlePay(planData?.id);

          //remove state from location
          navigate('/our-plans', { state: { plan: null } });
        }
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
      notifyError(error?.response?.data?.error || "Something went wrong");
    }
  };

  useEffect(() => {
    getAllMyPlans();
  }, []);

  

  useEffect(() => {
    const script = document.createElement("script");
    script.src = process.env.REACT_APP_PEACH_CHECKOUT_URL;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const handlePay = async (plan_id) => {
    setLoading(true);
    dispatch(startLoader());
    setPaymentReady(false);

    try {
      const resp = await createCheckout({
        plan_id: plan_id,
      });

      const data = await resp.data;

      if (window.Checkout && data.checkoutId) {
        // Payment link is ready, open modal
        setPaymentReady(true);
        setShowPaymentModal(true);

        // Small delay to ensure modal is rendered before rendering checkout
        setTimeout(() => {
          // const checkout = window.Checkout.initiate({
          //   key:
          //     process.env.REACT_APP_PEACH_ENTITY_ID ||
          //     "8ac7a4c89b2a46a7019b2bad6fdf025c",
          //   checkoutId: data.checkoutId,
          // });

          // checkout.render("#payment-form");
          const checkout = window.Checkout.initiate({
            key:
              process.env.REACT_APP_PEACH_ENTITY_ID,
            checkoutId: data.checkoutId,
            events: {
              onCompleted: (event) => {
                // console.log("Payment completed event:", event);
                notifySuccess("Payment successful!");
                handleCloseModal();
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
                // window.location.reload();
                // e.g., update subscription UI or call backend to update DB
              },
              onCancelled: (event) => {
                console.log("Payment cancelled:", event);
                notifyError("Payment cancelled");
                handleCloseModal();
              },
              onExpired: (event) => {
                console.log("Payment expired:", event);
                notifyError("Session expired");
                handleCloseModal();
              },
              onError: (event) => {
                console.error("Payment error:", event);
                notifyError("An error occurred during payment");
                handleCloseModal();
              },
            },

            onClose: () => {
              console.log("Peach checkout closed by user");
              handleCloseModal();
            },
          });

          checkout.render("#payment-form");
        }, 100);
      } else {
        console.error("Peach Checkout script not loaded or checkoutId missing");
      }
    } catch (error) {
      console.error("Error creating checkout:", error);
    } finally {
      setLoading(false);
      dispatch(stopLoader());
    }
  };

  const handleContact = async () => {
    setShowContactModal(true);
  };

  const handleCloseContactModal = () => {
    setShowContactModal(false);
  };

  const handleCloseModal = () => {
    setShowPaymentModal(false);
    setPaymentReady(false);
    // Clear the payment form content
    const paymentForm = document.getElementById("payment-form");
    if (paymentForm) {
      paymentForm.innerHTML = "";
    }
  };

  const colors = [
    "#E0E7FF", // Soft Indigo (trust, premium)
    "#ECFDF5", // Light Mint Green (growth, positive)
    "#FFF7ED", // Soft Peach (warm, friendly)
    "#F0F9FF", // Light Sky Blue (clean, calm)
    "#FDF2F8", // Light Rose Pink (subtle highlight)
  ];



  return (
    <div className="our-plans-container">
      <div className="plans-grid">
        {plans?.length > 0 &&
          plans.map((planData, i) => (
            <Card
              key={i}
              plan={planData?.name}
              price={planData?.name == "Trial" ? "Free" : planData?.price}
              uploadsPerMonth={planData?.credits}
              features={planData?.modules || []}
              allFeatures={allModules}
              notes={planData?.notes}
              color={colors[i % colors.length]}
              isCurrentPlan={currentPlan === planData?.name}
              buttonType={
                currentPlan === planData?.name ? "Current Plan" : "Buy Now"
              }
              priceText={planData.price ? "per user per month" : ""}
              isCustom={planData.name == "School customized" ? true : false}
              handlePay={() => handlePay(planData?.id)}
              handleContact={() => handleContact()}
              onceoffPaymentAmount={planData?.onceoffPaymentAmount > 0 ? planData?.onceoffPaymentAmount : false}
            />
          ))}
      </div>
      {/* <button onClick={handlePay} disabled={loading}>
        {loading ? "Processing..." : "Pay Now"}
      </button> */}

      {/* Payment Modal */}
      {showPaymentModal && paymentReady && (
        <div className="payment-modal-overlay" onClick={handleCloseModal}>
          <div
            className="payment-modal-container"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="payment-modal-head">
              <div className="payment-modal-head-text">Complete Payment</div>
              <img
                style={{ cursor: "pointer" }}
                onClick={handleCloseModal}
                src="/close.svg"
                alt="Close"
              />
            </div>
            <div className="payment-modal-body">
              <div
                className="d-flex justify-content-center peach-payment-form"
                id="payment-form"
              ></div>
            </div>
          </div>
        </div>
      )}

      {/* Contact Us Modal */}
      <ContactUs isOpen={showContactModal} onClose={handleCloseContactModal} />
    </div>
  );
};

export default Index;
